module.exports = "MessageFormat.locale.es_PY = function ( n ) {\n    if ( n === 1 ) {\n        return \"one\";\n    }\n    return \"other\";\n};"


/*****************
 ** WEBPACK FOOTER
 ** /tmpfs/src/git/fitbit-site-weightsite/catpack/web_loaders/script-loader/~/raw-loader!./js/lib/messageformat/locale/es_PY.js
 ** module id = 106
 ** module chunks = 0 1 2 3 4
 **/